import { render, staticRenderFns } from "./MerchantDetail.vue?vue&type=template&id=144f6a98&scoped=true&"
import script from "./MerchantDetail.vue?vue&type=script&lang=js&"
export * from "./MerchantDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144f6a98",
  null
  
)

export default component.exports